import script from "./ApplicationHelpView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationHelpView.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationHelpView.vue?vue&type=style&index=0&id=7c175f07&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c175f07"]])

export default __exports__